import React from "react";
import './../Common/Custom.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Carousel from 'react-bootstrap/Carousel';

import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}))



function Home() {

  
  return (
    <>
      <div className="homecarousal">
       <div className="header">
        <img
          className="d-block"
          src={process.env.PUBLIC_URL + '/images/logo.webp'}
          alt="Ananda"
        />
       </div>
        <Carousel>
      <Carousel.Item>
   
        <img
          className="d-block w-100"
          src={process.env.PUBLIC_URL + '/images/banner1.webp'}
          alt="Ananda"
        />
        <Carousel.Caption>
          <p>Untouched Delivery</p>
          <h3>Download <b>Ananda <br /> App Now!</b></h3>
          <Stack direction="row" spacing={2} className="appimg">
           
             <Item>                
             <img
                src={process.env.PUBLIC_URL + '/images/play-store.webp'}
                alt="Ananda"
                />
             </Item>
          </Stack>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={process.env.PUBLIC_URL + '/images/banner2.webp'}
          alt="Ananda"
        />
        <Carousel.Caption>
          <p>Untouched Delivery</p>
          <h3>Download <b>Ananda <br /> App Now!</b></h3>
          <Stack direction="row" spacing={2} className="appimg">
           
             <Item>                
             <img
                src={process.env.PUBLIC_URL + '/images/play-store.webp'}
                alt="Ananda"
                />
             </Item>
          </Stack>
        </Carousel.Caption>

      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={process.env.PUBLIC_URL + '/images/banner3.webp'}
          alt="Ananda"
        />

        <Carousel.Caption>
          <p>Untouched Delivery</p>
          <h3>Download <b>Ananda <br /> App Now!</b></h3>
          <Stack direction="row" spacing={2} className="appimg">
           
             <Item>                
             <img
                src={process.env.PUBLIC_URL + '/images/play-store.webp'}
                alt="Ananda"
                />
             </Item>
          </Stack>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
      
      </div>
      


        

        



    </>
  );
}


export default Home;
